import { createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/store/store";

import { IUniversalSearchFilter } from "@/models";

const initialState: IUniversalSearchFilter = {
  schedule: {} as Record<string, string>,
  ipDashboard: {} as Record<string, string>,
  reception: {} as Record<string, string>,
  clinicAppointments: {} as Record<string, string>,
  currentActivBottomNavItem: null as number | null,
};

const universalSearchFilterSlice = createSlice({
  name: "universalSearchFilter",
  initialState,
  reducers: {
    setScheduleFilter: (state, action) => {
      state.schedule = action.payload;
    },
    setIpDashboardFilter: (state, action) => {
      state.ipDashboard = action.payload;
    },
    setReceptionFilter: (state, action) => {
      state.reception = action.payload;
    },
    setClinicAppointmentsFilter: (state, action) => {
      state.clinicAppointments = action.payload;
    },
    setCurrentActivBottomNavItem: (state, action) => {
      state.currentActivBottomNavItem = action.payload;
    },
  },
  extraReducers: () => {},
});

export const universalSearchFilterRootSelector = (state: RootState) =>
  state.universalSearchFilter;

export const universalSearchFilterDetails = createSelector(
  [universalSearchFilterRootSelector],
  (state) => {
    return {
      schedule: state.schedule,
      ipDashboard: state.ipDashboard,
      reception: state.reception,
      clinicAppointments: state.clinicAppointments,
      currentActivBottomNavItem: state.currentActivBottomNavItem,
    };
  }
);
export const {
  setScheduleFilter,
  setIpDashboardFilter,
  setReceptionFilter,
  setClinicAppointmentsFilter,
  setCurrentActivBottomNavItem,
} = universalSearchFilterSlice.actions;
export default universalSearchFilterSlice.reducer;
